module.exports = __webpack_public_path__ + "static/media/image_21.cb46a2fd.png";